import React from 'react';
import i18next from "../../i18n";
import { actionTypes, settingsFormTypes } from '../../constants';
import { getArrayIds } from '../helpers/HelperFunctions';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import * as ModalDialogsTemplates from '../ModalDialogsTemplates';
export { loadData } from './ListOfCompanies';
export async function actionHandlerCallback(actionType, ids = []) {
    const { userId } = this.props;
    if (ids.length > 0) {
        // eslint-disable-next-line default-case
        switch (actionType) {
            case actionTypes.add:
                let handleSuccess = function () {
                    fetch(`/account/join`, { method: 'Post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId: userId, counterpartyAssoc: ids[0] }) })
                        .then((response) => {
                            if (!response.ok) ModalDialogsTemplates.unknownErrorMessageDialog(); else ModalDialogsTemplates.messageDialog(i18next.t("message"), i18next.t("8"));
                        });
                }
                ModalDialogsTemplates.messageDialog(i18next.t("message"), i18next.t("9"), handleSuccess);
                break;
        }
    }
    await this.actionHandlerCallbackDefault(actionType, ids);
}
export function renderContent() {
    const { content, sortBy, isDesk, page, pageSize, pageCount, filterValues } = this.state;
    const { type, hideFilter } = this.props;
    if (content) {
        content.actionsForAll = [{
            "title": i18next.t("add"),
            "type": actionTypes.add,
            "isMultiaction": false,
            "btnClass": "btn-primary",
            "sortIndex": -1
        }];
    }
    return (
        <div>
            {type !== settingsFormTypes.settingsType && !hideFilter ?
                <TableFilterBlock filterValues={filterValues} onSearch={this.onSearch} exportFileName="companies" onSearchClear={this.onSearchClear} onColumnsUpdateHandler={this.onColumnsUpdateHandler} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} /> :
                ""
            }
            {content && content.columns &&
                <Table onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} allCount={content.allCount} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={content.actionsForAll} columns={content.columns} items={content.rows} showPagination={type !== settingsFormTypes.settingsType} sortBy={sortBy} isDesk={isDesk} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} />
            }
        </div>
    );
}